import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';

interface DashboardStatsProps {
  tasksDueToday: number | undefined;
  tasksOverdue: number | undefined;
}

export const DashboardStats = ({ tasksDueToday, tasksOverdue }: DashboardStatsProps) => {
  return (
    <AgxSpacer direction="horizontal" contentAlignment="center">
      <AgxTypography
        id="tasks-dashboard-todaysCount"
        type="body_ui"
        size="medium"
        color="var(--text-success)"
      >
        {tasksDueToday ?? '--'}
      </AgxTypography>
      <AgxTypography
        id="tasks-dashboard-todaysCount"
        type="body_ui"
        size="medium"
        color="var(--text-primary)"
      >
        {'\u00A0'}
        tasks today,
      </AgxTypography>
      <AgxTypography
        id="tasks-dashboard-todaysCount"
        type="body_ui"
        size="medium"
        color="var(--text-error)"
      >
        {'\u00A0'}
        {tasksOverdue ?? '--'}
      </AgxTypography>
      <AgxTypography
        id="tasks-dashboard-todaysCount"
        type="body_ui"
        size="medium"
        color="var(--text-primary)"
      >
        {'\u00A0'}Overdue tasks
      </AgxTypography>
    </AgxSpacer>
  );
};
